import useModalReducer from "hooks/useModal";
import { useCallback, useState } from "react";
import { ViewClaimsModal } from "../ViewClaimsModal";
import { ClaimsTable } from "../ClaimsTable";
import { useEffect } from "react";
import { claimsTableModalEmitter } from "../ClaimsTable/config";

const MyClaimsPage = () => {
	const { state, dispatch, actions } = useModalReducer();

	const showModal = useCallback((row) => {
		dispatch({
			type: actions.OPEN,
			payload: row,
		});
	}, []);

	const hideModal = useCallback(() => {
		dispatch({ type: actions.CLOSE });
	}, []);

	useEffect(() => {
		const unbind = claimsTableModalEmitter.on("showModal", showModal);
		return unbind;
	}, [showModal]);

	const [refetchCheck, setRefetchCheck] = useState(false);

	const refetch = useCallback(() => setRefetchCheck((prev) => !prev), []);

	return (
		<div className="relative content">
			<ViewClaimsModal state={state} showModal={showModal} hideModal={hideModal} self={true} deleteAction editAction refetch={refetch} />
			<ClaimsTable self={true} showModal={showModal} parentRefetchCheck={refetchCheck} />
		</div>
	);
};

export default MyClaimsPage;
